import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import getPersonName from "../../common/Name";
import getPhone, { getFormattedPhone } from "../../common/Phone";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class NeighborsCurrent extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const { isSilverReport } = this.props;
      if (isSilverReport) {
        const addressList = _.get(this.props.node, "addresses[0].address");
        if (addressList !== undefined) {
          _.forEach(addressList, (address, addIndex) => {
            const phonebookEntries = _.get(
              address,
              "neighbors[0].phoneBookEntry"
            );
            if (phonebookEntries && phonebookEntries.length > 0) {
              rows.push(
                <Table.Row
                  key={`row_neigh_${addIndex}`}
                  className="report-sub-section-header"
                >
                  <Table.Cell width={3}> Neighborhood of: </Table.Cell>
                  <Table.Cell width={8}>
                    <Address addressNode={address} {...this.props} />
                  </Table.Cell>
                  <Table.Cell width={2} />
                  <Table.Cell width={3} />
                </Table.Row>
              );

              recCount +=
                phonebookEntries !== undefined ? phonebookEntries.length : 0;
              _.forEach(
                phonebookEntries,
                (phonebookEntry, phoneBookEntryIndex) => {
                  rows.push(
                    <Table.Row
                      key={`row_phoneBookEntry_${addIndex}_${phoneBookEntryIndex}`}
                      className={
                        phoneBookEntryIndex % 2 === 1
                          ? "table-row-odd-child"
                          : ""
                      }
                    >
                      <Table.Cell>Address:</Table.Cell>
                      <Table.Cell colSpan={3}>
                        <Address
                          addressNode={phonebookEntry.address[0]}
                          {...this.props}
                        />
                      </Table.Cell>
                    </Table.Row>
                  );
                  const phones = _.get(phonebookEntry, "phones[0].phone");
                  const phoneNumbers = [];
                  _.forEach(phones, (phone) => {
                    const phoneNumber = _.get(phone, "phoneNumber[0]._", "");
                    if (phoneNumber !== "")
                      phoneNumbers.push(getFormattedPhone(phoneNumber));
                  });
                  const neighborName = _.get(phonebookEntry, "name[0]");
                  if (neighborName) {
                    rows.push(
                      <Table.Row
                        key={`phone_row_${addIndex}_${phoneBookEntryIndex}`}
                        className={
                          phoneBookEntryIndex % 2 === 1
                            ? "table-row-odd-child"
                            : ""
                        }
                      >
                        <Table.Cell className="text-bold">Contact:</Table.Cell>
                        <Table.Cell>
                          {getPersonName(
                            _.get(neighborName, "firstName[0]._", ""),
                            "",
                            _.get(neighborName, "lastName[0]._", ""),
                            props
                          )}
                        </Table.Cell>
                        <Table.Cell width={2}>
                          <span className="text-bold"> Phone: </span>
                        </Table.Cell>
                        <Table.Cell width={3}>
                          {phoneNumbers.map((p, i) => (
                            <p key={`ph_no_${i}`} className="margin-bottom-0">
                              {p}
                            </p>
                          ))}
                        </Table.Cell>
                      </Table.Row>
                    );
                  }
                }
              );
            }
          });
        } else {
          rows.push(
            <Table.Row key={`no_recs_row`}>
              <Table.Cell colSpan={2}>No Records found</Table.Cell>
            </Table.Row>
          );
        }
      } else {
        const addressList = _.get(
          props.reportData,
          "personReport.compReportResponse[0].individual[0].neighbors[0].neighborhood"
        );
        if (addressList !== undefined) {
          _.forEach(addressList, (address, addIndex) => {
            rows.push(
              <Table.Row
                key={`row_neigh_${addIndex}`}
                className="report-sub-section-header"
              >
                <Table.Cell width={3}> Neighborhood of: </Table.Cell>
                <Table.Cell width={8}>
                  <Address
                    addressNode={address.subjectAddress[0].address[0]}
                    {...this.props}
                  />
                </Table.Cell>
                <Table.Cell width={5} />
              </Table.Row>
            );

            const phoneInfos = _.get(
              address,
              "neighborAddresses[0].neighborAddress"
            );
            recCount += phoneInfos !== undefined ? phoneInfos.length : 0;
            _.forEach(phoneInfos, (phoneInfo, phoneInfoIndex) => {
              rows.push(
                <Table.Row
                  key={`row_phoneinfo_${addIndex}_${phoneInfoIndex}`}
                  className={
                    phoneInfoIndex % 2 === 1 ? "table-row-odd-child" : ""
                  }
                >
                  <Table.Cell>Address:</Table.Cell>
                  <Table.Cell>
                    <Address
                      addressNode={phoneInfo.address[0]}
                      {...this.props}
                    />
                  </Table.Cell>
                  <Table.Cell>
                    Dates of occupancy:{" "}
                    {_.get(phoneInfo, "dateFirstSeen[0].year[0]._", "")}-
                    {_.get(phoneInfo, "dateLastSeen[0].year[0]._", "")}
                  </Table.Cell>
                </Table.Row>
              );
              const phones = _.get(phoneInfo, "phones");
              _.forEach(phones, (phone, phoneIndex) => {
                const contact = _.get(phone, "phone[0].listingName[0]._", "");
                const tokens = contact.split(" ");
                const phone1 = _.get(phone, "phone[0].phone10[0]._", "");
                rows.push(
                  <Table.Row
                    key={`phone_row_${addIndex}_${phoneInfoIndex}_${phoneIndex}`}
                    className={
                      phoneInfoIndex % 2 === 1 ? "table-row-odd-child" : ""
                    }
                  >
                    <Table.Cell className="text-bold">Contact:</Table.Cell>
                    <Table.Cell>
                      {getPersonName(
                        tokens && tokens.length > 1 ? tokens[1] : "",
                        "",
                        tokens && tokens.length > 0 ? tokens[0] : "",
                        props
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      <span className="text-bold"> Phone: </span>
                      {getPhone(phone1, props)}
                    </Table.Cell>
                  </Table.Row>
                );
              });

              const nameInfos = _.get(phoneInfo, "residents[0].identity");
              _.forEach(nameInfos, (names, nameIndex) => {
                const age = _.get(names, "age[0]._", "");
                const dod = _.get(names, "DOD[0].year[0]._", "");
                rows.push(
                  <Table.Row
                    key={`row_contact_${addIndex}_${phoneInfoIndex}_${nameIndex}`}
                    className={
                      phoneInfoIndex % 2 === 1 ? "table-row-odd-child" : ""
                    }
                  >
                    <Table.Cell />
                    <Table.Cell colSpan={2}>
                      <span className="text-bold"> Name: </span>{" "}
                      {getPersonName(
                        _.get(names, "name[0].first[0]._", ""),
                        _.get(names, "name[0].middle[0]._", ""),
                        _.get(names, "name[0].last[0]._", ""),
                        props
                      )}
                      {age !== "" ? ` Age: ${age}` : null}
                      {dod !== "" ? ` DOD: ${dod}` : null}
                    </Table.Cell>
                  </Table.Row>
                );
              });
            });
          });
        } else {
          rows.push(
            <Table.Row key={`no_recs_row`}>
              <Table.Cell colSpan={2}>No Records found</Table.Cell>
            </Table.Row>
          );
        }
      }
    }

    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Neighbors Current"}
        rows={this.state.rows}
      />
    );
  }
}

export default NeighborsCurrent;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/NeighborsCurrent.js